import React, { useState } from 'react';
import { copyToClipboard, stripeDashboardProductUrl } from './planStripeStatus';

export default function StripeIdField({
  label,
  value,
  hint,
  linkType = null
}) {
  const [copied, setCopied] = useState(false);
  const display = value || '—';
  const hasValue = Boolean(value);

  const handleCopy = async () => {
    if (!hasValue) return;
    const ok = await copyToClipboard(value);
    if (ok) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const externalUrl = linkType === 'product' && hasValue
    ? stripeDashboardProductUrl(value)
    : null;

  return (
    <div className="sp-stripe-id-field">
      <label>{label}</label>
      <div className={`sp-stripe-id-box ${hasValue ? 'has-value' : 'empty'}`}>
        <code className="sp-stripe-id-value" title={display}>{display}</code>
        <div className="sp-stripe-id-actions">
          {hasValue && (
            <button
              type="button"
              className="sp-stripe-id-btn"
              onClick={handleCopy}
              title="Copy to clipboard"
            >
              <i className={`fa-solid ${copied ? 'fa-check' : 'fa-copy'}`} />
              {copied ? 'Copied' : 'Copy'}
            </button>
          )}
          {externalUrl && (
            <a
              href={externalUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="sp-stripe-id-btn sp-stripe-id-link"
              title="Open in Stripe Dashboard"
            >
              <i className="fa-solid fa-arrow-up-right-from-square" />
              Stripe
            </a>
          )}
        </div>
      </div>
      {hint && <p className="sp-stripe-id-hint">{hint}</p>}
    </div>
  );
}
